// ============================================================
// agent_slash_commands.js — 채팅 컴포저 슬래시 커맨드 판정(순수 로직)
// ============================================================
// 역할: 사용자가 컴포저에 친 텍스트가 "에이전트에게 보낼 말"인지 "webxcom 이 자기가
//       처리할 슬래시 커맨드"인지 가른다. 현재 커맨드는 /clear 하나뿐이다.
//
// /clear 의 의미(2026-08-10 확정):
//   화면을 비우고 "새 대화(conversation)"로 전환한다. 이전 이력은 서버에 그대로
//   남는다 — 새 conversation 은 ar_conversations 의 별도 행이라 기존 ar_messages 를
//   지우지 않는다. 즉 "삭제"가 아니라 "새 판 깔기"다.
//
// 왜 컨트롤러 밖으로 뺐나:
//   agent_expiry_cards.js 와 같은 이유다. 판정이 조금만 헐거워지면(예: startsWith
//   으로 바꾸면) "/clear 해줘" 같은 정상 명령까지 삼켜 대화가 통째로 날아간 것처럼
//   보인다. DOM·Stimulus 없이 검증할 수 있게 순수 함수로 떼어 node 테스트
//   (test/javascript/agent_slash_commands_test.js)가 직접 태운다.
//
// 주의사항:
//   - 오직 "정확히 /clear" 만 커맨드다. /clearx, clear, "/clear 지금" 은 전부 일반
//     텍스트로 흘러야 한다(에이전트가 그대로 받는다). 접두사 매칭 금지.
//   - 다른 /xxx 입력도 특별 처리하지 않는다 — 여기 목록에 없으면 전부 일반 텍스트다.
// ============================================================

// "새 대화" 폼(button_to)을 찾는 DOM 계약.
// WHY 셀렉터인가: 이 폼은 Stimulus 컨트롤러 엘리먼트(.ac-pane) 밖, 대화 목록 헤더에
//   있다(chat/_agent_talk.html.erb, agent_chats/show.html.erb). Stimulus 타깃은
//   컨트롤러 하위에서만 잡히므로 target 으로는 도달할 수 없다.
// WHY 경로(action) 매칭이 아닌 전용 data 속성인가: action$="/chat/conversations" 로
//   잡으면 라우트 문자열이 바뀌는 순간 조용히 죽는다. 뷰가 명시적으로 표식을 달아
//   "이 폼이 /clear 의 대상"임을 계약으로 못박는다.
export const NEW_CONVERSATION_SELECTOR = "[data-agent-chat-new-conversation]"

// 관용 범위: 앞뒤 공백(호출부에서 이미 trim 되지만 방어)과 대소문자만 허용한다.
// 중간 공백·꼬리 인자는 허용하지 않는다(위 주의사항 참조).
const CLEAR_COMMAND = "/clear"

/**
 * 입력 텍스트가 /clear 커맨드인지 판정한다.
 * @param {*} text 컴포저 원문(문자열이 아니면 false)
 * @returns {boolean} 정확히 "/clear"(대소문자·앞뒤 공백 무시)면 true
 */
export function isClearCommand(text) {
  if (typeof text !== "string") return false
  return text.trim().toLowerCase() === CLEAR_COMMAND
}
